import { render } from "./formAnswersViewer.vue?vue&type=template&id=3898aef4&ts=true"
import script from "./formAnswersViewer.vue?vue&type=script&lang=ts"
export * from "./formAnswersViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__